/*
 * Copyright 1999-2024 Jagex Ltd.
 */
export enum StatusCode {
  // 2xx
  Ok = 200,
  NoContent = 204,
  // 3xx
  TemporaryRedirect = 307,
  // 4xx
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  UnprocessableEntity = 422,
  // 5xx
  InternalServerError = 500
}

export const TARGET_ROUTE_STORAGE_KEY = 'targetRoute';
export const LANG_PLACEHOLDER = '<lang>';
export const LANG_QUERY_NAME = 'lang';
export const LOCALE_MAP = {
  'en-GB': 'l=0',
  'de-DE': 'l=1',
  'fr-FR': 'l=2',
  'pt-BR': 'l=3'
};

export const MEDIA_SCREEN_BREAKPOINTS = {
  xs: '575px',
  s: '767px',
  m: '991px',
  l: '1199px',
  xl: '1600px'
};

export const SOCIAL_PROVIDERS = {
  amazon: 'amazon',
  steam: 'steam',
  default: 'default'
};

export const PROVIDER_ERROR_CODES = {
  PROVIDER_ACCOUNT_ALREADY_CLAIMED: 'SOCIAL_VERIFIER_ACCOUNT_ALREADY_CLAIMED',
  PROVIDER_ALREADY_LINKED: 'SOCIAL_VERIFIER_ACCOUNT_ALREADY_LINKED'
};

export enum CookieName {
  LinkingSourceType = 'linking__source-type',
  LinkingRedirectUrl = 'linking__redirect-url',
  Provider = 'provider'
}

export const HEADER_LOCALE = 'locale';

export enum RedirectUrlValidator {
  AccountCreation = 'ACCOUNT_CREATION'
}
export const UNKNOWN_STEAM_NAME = 'Unknown';
